import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import ContentBox from '../../../layout/component/ContentBox'
import { LANGUAGE_LIST } from '../../../internationalization/const'


const EmailTemplateVariantSelection = ({ userSelection, processList, templateList, isEmailAdmin, changeProcess, findEmailTemplateById, changeLocale, createEmailTemplateVariant, getProcessMacroList }) => {
    const showCreateButton = isEmailAdmin && userSelection.emailTemplateId && userSelection.locale

    return (
        <div>
            <ContentBox title="Manage Email Templates">
                <Row>
                    <Column size={4}>
                        <LabelInput label="Process">
                            <Select
                                object={userSelection}
                                style={{ height: '30px' }}
                                name="processName"
                                addEmpty={true}
                                valueList={processList}
                                onChange={(name, value) => {
                                    changeProcess(name, value)
                                    getProcessMacroList()
                                }}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={4}>
                        <LabelInput label="Template">
                            <Select
                                object={userSelection}
                                style={{ height: '30px' }}
                                name="emailTemplateId"
                                addEmpty={true}
                                valueList={templateList}
                                renderer={({ technicalName, subject, text }) => {
                                    return technicalName
                                }}
                                onChange={findEmailTemplateById}
                            />
                        </LabelInput>
                    </Column>
                    <Column size={4}>
                        <LabelInput label="Language">
                            <Select
                                object={userSelection}
                                style={{ height: '30px' }}
                                name="locale"
                                addEmpty={false}
                                valueList={LANGUAGE_LIST}
                                onChange={changeLocale}
                            />
                        </LabelInput>
                    </Column>
                </Row>
                {showCreateButton && (
                    <Row top="M">
                        <Column size={12}>
                            <button
                                className="btn btn-warning btn-sm"
                                onClick={createEmailTemplateVariant}>
                                <i className="fa fa-plus-square"/>&#160;new variant
                            </button>
                        </Column>
                    </Row>
                )}
            </ContentBox>
        </div>
    )
}


EmailTemplateVariantSelection.propTypes = {
    userSelection: PropTypes.object.isRequired,
    processList: PropTypes.array.isRequired,
    templateList: PropTypes.array.isRequired,

    changeProcess: PropTypes.func.isRequired,
    findEmailTemplateById: PropTypes.func.isRequired,
    changeLocale: PropTypes.func.isRequired,
    createEmailTemplateVariant: PropTypes.func.isRequired,
    getProcessMacroList: PropTypes.func.isRequired,
}

export default EmailTemplateVariantSelection



// WEBPACK FOOTER //
// ./src/modules/email/component/manage/EmailTemplateVariantSelection.js